import landing from './landing';
import contentful from './contentful';
import custom from './custom';
import legal from './legal';
import user from './user';
import wizard from './wizard';

const index = {
  landing,
  contentful,
  custom,
  legal,
  user,
  wizard,
};

export default index;